import CountryPageTemplate from "../../components/country/CountryPageTemplate";
import { countryPages } from "../../data/countries";

function EuropePage() {
  return <CountryPageTemplate country={countryPages.europe} />;
}

export default EuropePage;
